import React from 'react'
import { Loader2 } from 'lucide-react'

export default function Loader({ testId }: { testId?: string }) {
  return (
    <div className="flex justify-center items-center">
      <div
        className="flex justify-center items-center flex-col font-normal text-dark-blue my-6 rounded-2xl bg-white/50 p-8 h-[115px] w-full sm:w-[80%] min-w-[500px] max-w-[560px] shadow-[0_4px_30px_rgba(0,0,0,0.05)] [backdrop-filter:blur(2px)]"
        data-testid={testId}
      >
        <div>
          <Loader2 className="animate-spin" width={24} height={24} aria-label="Loading" />
        </div>
        <div className="mt-2">Please wait a few moments.</div>
      </div>
    </div>
  )
}
